import { round } from "lodash";

export const calculateItemDoses = (item, { wetness, machined, totalArea, appTypeId }, type) => {
	let dose_100L = parseFloat(item.dose_100L) || 0;
	let dose_ha = parseFloat(item.dose_ha) || 0;

	if (type === "dose_100L" && wetness) {
		dose_ha = round((dose_100L * wetness) / 100 / 1000, 2);
	} else if (type === "dose_ha" && wetness) {
		dose_100L = round((dose_ha * 100 * 1000) / wetness, 2);
	} else if (!type && wetness) {
		if (dose_100L) {
			dose_ha = round((dose_100L * wetness) / 100 / 1000, 2);
		} else if (dose_ha) {
			dose_100L = round((dose_ha * 100 * 1000) / wetness, 2);
		}
	}

	const dose_machinery = machined ? (dose_100L * machined) / 1000 / 100 : 0;
	const quantity_machinery = totalArea && machined ? (totalArea * wetness) / machined : 0;

	let quantity = 0;
	if ([2, 4, 5].includes(Number(appTypeId))) {
		quantity = totalArea * dose_ha;
	} else if (quantity_machinery && dose_machinery) {
		quantity = quantity_machinery * dose_machinery;
	}

	return {
		...item,
		dose_100L: dose_100L || "",
		dose_ha: dose_ha || "",
		dose_machinery: dose_machinery || "",
		quantity_machinery: quantity_machinery || "",
		quantity: quantity || "",
	};
};
